// Function loadHubHero loads the HubHero class by dynamically importing the js on demand if needed

export function loadHubHero($parentEl, isList = false) {


	let $wg = $parentEl.querySelector('[data-wg="HubHero"]');

	if(!$wg) {
		// console.info('HubHero: no widget found');
		return Promise.reject('HubHero widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-hub-hero-chunk" */ '../widgets/hubHero').then(wg => {

		const { HubHero } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="HubHero"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new HubHero($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new HubHero($wg);
		}


	}).catch(error => error+'An error occurred while loading the HubHero widget');

}
